<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <b-col class="col-content">
      <b-form-group id="customTestMethodDetails">
        <b-col lg="6" style="padding-left: 0px; padding-right: 0px;">
          <b-row>
            <b-col>
              <h2>
                {{$t('name')}}:
              </h2>
              <b-form-input
                style="margin-bottom: 1rem;"
                v-model="currentCustomTestMethod.name"
              />
            </b-col>
          </b-row>
          <!-- <b-row style="margin-bottom: 15px">
            <b-col>
              <h2>
                {{$t('privatePage.custom_testmethods_question_format')}}:
              </h2>
              <b-form-select
                style="margin-bottom: 1rem;"
                :options="questionFormats"
                v-model="currentCustomTestMethod.questionFormatId"
                value-field="id"
                text-field="name"
                v-if="!currentCustomTestMethod.id"
              />
              <span v-else>
                {{currentCustomTestMethod.questionFormat}}
              </span>
              {{selectedQuestionFormat}}
            </b-col>
          </b-row> -->
          <b-row>
            <b-col>
              <h2>
                {{$t('privatePage.instructions_header')}}:
              </h2>
              <b-form-select
                style="margin-bottom: 1rem;"
                :options="filteredInstructions"
                v-model="currentCustomTestMethod.instructionId"
                value-field="id"
                text-field="name"
              />
            </b-col>
          </b-row>
          <b-row v-if="currentCustomTestMethod.totalEstimatedQuestionTime">
            <b-col>
              <h2>
                {{$t('privatePage.custom_testmethods_estimated_time')}}:
              </h2>
              <p style="font-style: italic; margin-bottom: 0px; font-size: 12px;">
                {{$t('privatePage.custom_testmethods_estimated_time_info')}}
              </p>
              {{currentCustomTestMethod.totalEstimatedQuestionTime}}
            </b-col>
          </b-row>
        </b-col>
      </b-form-group>
      <b-card :header="$t('privatePage.my_testmethod_header')">
        <b-form-group id="addTests" style="margin-bottom: 0px;">
          <b-row>
            <b-col>
              <b-card :header="$t('privatePage.custom_testmethods_available_scales')" style="background-color: #f5f4f4">
                <b-list-group>
                  <b-list-group-item
                    v-for="(availableScale, index) in availableScales" :key="index"
                  >
                    {{ availableScale.name }} - <span v-for="cc in availableScale.cc" :key="cc" style="margin-right: 0.4rem" :class="'flagItem flag-icon flag-icon-' + cc"></span>
                    <b-button
                      variant="primary"
                      class="fa fa-plus pull-right"
                      @click="onUpdateScaleLists(availableScales, currentCustomTestMethod.scales, index, availableScale)"
                    />
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            <b-col>
              <b-card :header="$t('privatePage.custom_testmethods_added_scales')" style="background-color: #f5f4f4">
                <b-list-group>
                  <b-list-group-item
                    v-for="(selectedScale, index) in currentCustomTestMethod.scales" :key="index"
                  >
                    {{ selectedScale.name }} - <span v-for="cc in selectedScale.cc" :key="cc" style="margin-right: 0.4rem" :class="'flagItem flag-icon flag-icon-' + cc"></span>
                    <b-button
                      variant="danger"
                      class="fa fa-minus pull-right"
                      @click="onUpdateScaleLists(currentCustomTestMethod.scales, availableScales, index, selectedScale)"
                    />
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-form-group>
      </b-card>
      <b-form-group class="mt-2 mb-4">
        <b-button type="submit" class="me-1" @click="beforeSaving(false)">{{ $t('save') }}</b-button>
        <b-button type="submit" class="me-1" @click="beforeSaving(true)">{{ $t('save_randomize') }}</b-button>
        <b-button variant="danger" type="reset">{{ $t('cancel') }}</b-button>
      </b-form-group>
    </b-col>
  </b-form>
</template>

<script>
export default {
  name: 'test-builder-detail-editor',
  props: [
    'availableScales',
    'questionFormat',
    'instructions',
    'currentCustomTestMethod'
  ],
  data() {
    return {
      selectedScales: [],
      doRandomize: true,
      selectedQuestionFormat: this.questionFormat.name
    }
  },
  computed: {
    filteredInstructions() {
      return this.instructions.filter(
        instruction => instruction.questionFormatId === this.questionFormat.id
      )
    }
  },
  methods: {
    onUpdateScaleLists(fromArray, toArray, index, value) {
      if (index < 0) {
        return
      }
      fromArray.splice(index, 1)
      toArray.push(value)
    },
    beforeSaving(doRandomize) {
      this.doRandomize = doRandomize
    },
    onSubmit(evt) {
      evt.preventDefault()
      if (this.currentCustomTestMethod.scales.length < 3) {
        this.$emit('showScaleCountError')
        return
      }

      let scales = this.selectedScales || []
      let ids = []

      scales.forEach(scale => {
        ids.push(scale.id)
      })

      this.currentCustomTestMethod.doRandomize = this.doRandomize
      this.currentCustomTestMethod.scaleIds = ids
      this.currentCustomTestMethod.questionFormatId = this.questionFormat.id

      this.$emit('onSubmit', this.currentCustomTestMethod)
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    }
  },
  watch: {
    filteredInstructions() {
      this.filteredInstructions.forEach(instruction => {
        if (instruction.isStandardInstruction) {
          this.currentCustomTestMethod.instructionId = instruction.id
        }
      })
    }
  }
  // ,
  // created() {
  //   debugger
  //   if (
  //     this.currentCustomTestMethod !== undefined &&
  //     this.currentCustomTestMethod.id
  //   ) {
  //     debugger
  //     this.$emit(
  //       'onQuestionFormatChange',
  //       this.currentCustomTestMethod.questionFormatId
  //     )
  //   }
  // }
}
</script>

<style scoped>
.testsuiteCard {
  margin-bottom: 30px;
}
</style>
